import React, { Component } from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import style from "./TodayAppoinments.module.css";
import todaysAppointmentWhite from "../../assets/images/dashboard/todays-appointment-white.svg";
import { TableOptions } from "../../utils/messageConstants";
import { Link } from "react-router-dom";

let order = "desc";
export class TodayAppoinments extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  handleBtnClick = () => {
    if (order === "desc") {
      this.refs.table.handleSort("asc", "name");
      order = "asc";
    } else {
      this.refs.table.handleSort("desc", "name");
      order = "desc";
    }
  };

  render() {
    const dashboardData = this.props.dashboardCounts;
    return (
      <div>
        <div className={`card ${style.todayAppCard}`}>
          
          <Link to={{
            pathname:"/app/appoinmentlist",
            params: {
              isTodaysAppointmentist:1
            }}}>
            <div className={`card-header ${style.todayAppHeader}`}>
              <div className="d-flex align-items-center dashboard-list-box">
                <img src={todaysAppointmentWhite} alt="Today's Appointments" />
                Today's Appointments
              </div>
              <i className="fa fa-ellipsis-v" aria-hidden="true"></i>
            </div>
          <div className="card-body dashboard-time-table-wrapper">
            <BootstrapTable ref="table" data={dashboardData.todaysList} options={TableOptions} version="4">
              <TableHeaderColumn
                dataField="party_name"
                isKey={true}
                // dataSort={true}
                width={"65%"}
              >
                Contact Name
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="startTime"
                // dataSort={true}
                width={"35%"}
              >
                Start Time
              </TableHeaderColumn>
            </BootstrapTable>
          </div>
          </Link>
        </div>
      </div>
    );
  }
}


export default TodayAppoinments;

